import React from 'react';
import { motion } from 'framer-motion';
import { Magnet, Calendar, CheckCircle2 } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Solution() {
  const days = [{
    day: 'Día 1',
    title: 'El Clon del Socio Ideal',
    desc: "Aprende a identificar quién es exactamente la persona que te dirá 'SÍ' sin objeciones."
  }, {
    day: 'Día 2-3',
    title: 'La Bio y el Feed Blindado',
    desc: 'Configuramos tu perfil para que sea una vitrina profesional de 24/7.'
  }, {
    day: 'Día 4-5',
    title: 'Ingeniería de Reels e Historias',
    desc: 'Ganchos específicos para Networkers que generan comentarios, no solo vistas.'
  }, {
    day: 'Día 6-7',
    title: 'El Cierre Magnético',
    desc: 'Guiones exactos para pasar del comentario de Instagram a la presentación de negocio sin presión.'
  }];
  return <section className="bg-brand-darker px-6 py-20 md:py-28 relative" data-id="element-222">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-gold/5 blur-[100px] rounded-full pointer-events-none" data-id="element-223"></div>

      <div className="mx-auto max-w-5xl relative z-10" data-id="element-224">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-225">
          <div className="inline-flex items-center justify-center p-4 bg-brand-gold/10 rounded-full mb-6" data-id="element-226">
            <Magnet className="w-10 h-10 text-brand-gold" data-id="element-227" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-228">
            El Método del{' '}
            <span className="text-brand-gold" data-id="element-229">"Networker Magnético"</span>
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed" data-id="element-230">
            No es un curso teórico. Es un manual operativo de 7 días diseñado
            para cambiar tu identidad digital. En lugar de perseguir, instalamos
            un "embudo magnético" en tu perfil que filtra a los curiosos y solo
            atrae a personas que ya tienen el deseo de emprender o consumir lo
            que ofreces.
          </p>
        </motion.div>

        <div className="bg-brand-light border border-slate-800 rounded-2xl p-8 md:p-12 mb-16" data-id="element-231">
          <div className="text-center mb-12" data-id="element-232">
            <h3 className="text-2xl md:text-3xl font-bold text-white flex items-center justify-center gap-3" data-id="element-233">
              <Calendar className="w-8 h-8 text-brand-gold" data-id="element-234" />
              Lo que obtienes en los 7 Días
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-235">
            {days.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: index % 2 === 0 ? -20 : 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex gap-4 items-start" data-id="element-236">
                <div className="flex-shrink-0 mt-1" data-id="element-237">
                  <CheckCircle2 className="w-6 h-6 text-brand-gold" data-id="element-238" />
                </div>
                <div data-id="element-239">
                  <h4 className="text-xl font-bold text-white mb-2" data-id="element-240">
                    <span className="text-brand-gold mr-2" data-id="element-241">{item.day}:</span>
                    {item.title}
                  </h4>
                  <p className="text-slate-400" data-id="element-242">{item.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </div>

        <div className="flex justify-center" data-id="element-243">
          <CTAButton data-id="element-244" />
        </div>
      </div>
    </section>;
}